var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessagecenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.99878 6.79705V6.79705C2.99878 7.3968 3.29865 7.89659 3.79845 8.29643L9.79595 12.3947C11.1954 13.2943 12.8947 13.2943 14.2941 12.3947L20.2916 8.39639C20.6914 7.89659 20.9913 7.3968 20.9913 6.79705V6.79705C20.9913 5.79747 20.1916 4.9978 19.192 4.9978H4.79803C3.79845 4.9978 2.99878 5.79747 2.99878 6.79705Z",
    stroke: "#EAECF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.99878 6.99707V16.9929C2.99878 18.0924 3.8984 18.9921 4.99795 18.9921H18.9921C20.0917 18.9921 20.9913 18.0924 20.9913 16.9929V6.99707",
    stroke: "#EAECF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58643 18.4042L9.67789 12.3127",
    stroke: "#EAECF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.354 12.3547L20.4035 18.4042",
    stroke: "#EAECF0",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessagecenter);
export default __webpack_public_path__ + "static/media/messagecenter.aff3a5efc23edc219b8aa625b895a90d.svg";
export { ForwardRef as ReactComponent };